<template>
  <div class="info-card max-w-sm text-center shadow m-4">
    <div class="p-6 py-14">
      <img :src="image" class="icon mx-auto mb-8" />
      <TypeDisplay
        :variant="$options.Typography.Display.MEGA"
        :weight="$options.Typography.Weights.STRONG"
        tag="p"
        class="info-title mb-6"
      >
        {{ title }}
      </TypeDisplay>
      <TypeBody
        :variant="$options.Typography.Body.LARGE"
        :weight="$options.Typography.Weights.REGULAR"
        tag="p"
        class="info-body"
      >
        {{ body }}
      </TypeBody>
    </div>
  </div>
</template>

<script>
import { TypeDisplay, TypeBody, constants } from '@bambeehr/pollen';

const { Typography } = constants;
export default {
  name: 'WhyBambeeInfoCard',
  Typography,
  components: { TypeDisplay, TypeBody },
  props: {
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    body: {
      type: String,
      default: '',
    },
  },
};
</script>
